import React from 'react';
import { useACF } from '@context/ACFContext';
import { HortizontalSeparator } from '../cards/productCard/separator/separator.styled';
import { ArrowUp } from '@assets/icons/ArrowUp';
import {
	Footer as StyledFooter,
	FooterContent,
	FooterLogo,
	FooterMenu,
	FooterLinks,
	FooterCopyright,
	CopyrightText,
	FooterWrapper,
	BackButton,
} from './footer.styled';

const Footer: React.FC = () => {
	const defaultDisclaimer = `
    * The information contained within this site is not intended as a substitute for professional medical advice...
    ** Important Disclaimer: The information contained on ConsumerTestedReview.com is intended for informational and educational purposes only.
  `;

	const { postTemplate, generalSettings } = useACF();
	const footer_section = postTemplate?.review_page_v4_footer_settings;
	const textColor = footer_section?.footer_text_color;
	const buttonBackground = footer_section?.footer_button_color;
	const linkHover = footer_section?.footer_link_hover_color;

	if (!footer_section) return;

	return (
		<StyledFooter id="footer" $backgroundColor={footer_section?.footer_background_color}>
			<FooterWrapper>
				<FooterContent
					$textColor={textColor ?? '#fff'}
					dangerouslySetInnerHTML={{
						__html: footer_section?.tr_footer_disclaimer_text || defaultDisclaimer,
					}}
				></FooterContent>
				<HortizontalSeparator $width="100%" $spacing="16px" />
				<FooterMenu>
					<FooterLogo>
						<img
							loading="lazy"
							style={{ width: '100%', height: 'auto' }}
							src={
								typeof footer_section?.footer_logo === 'string'
									? footer_section.footer_logo
									: generalSettings?.logo
							}
							alt={generalSettings?.brand_name || 'site logo'}
							className="mon-img-24-h"
						/>
					</FooterLogo>

					{footer_section?.footer_links && (
						<FooterLinks
							$linkHover={linkHover ?? '#e0e0e0'}
							$textColor={textColor ?? '#fff'}
							className="row row-cols-3 justify-content-center align-items-center"
						>
							{footer_section.footer_links.map((item, index) => {
								return (
									<div className="menu-item" key={index}>
										{item.link_type === 'Custom link' ? (
											<a
												href={item.custom_link.custom_link_url}
												target="_blank"
												rel="noopener noreferrer"
											>
												{item.custom_link.tr_custom_link_label}
											</a>
										) : (
											<a href={item.post_link?.post_link_url}>{item.post_link.tr_post_link_title}</a>
										)}
									</div>
								);
							})}
						</FooterLinks>
					)}
					<BackButton $backgroundColor={buttonBackground ?? '#636363'} href="#main-product">
						<span>{footer_section.tr_footer_back_to_top_label}</span>
						<ArrowUp />
					</BackButton>
				</FooterMenu>
				<HortizontalSeparator $width="100%" $spacing="16px" />
				<FooterCopyright>
					<CopyrightText $textColor={textColor ?? '#fff'} style={{ lineHeight: '20px' }}>
						{footer_section.tr_footer_copyright_text}
					</CopyrightText>
				</FooterCopyright>
			</FooterWrapper>
		</StyledFooter>
	);
};

export default Footer;
